import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`UN HUMANITARIAN AIR SERVICE`}</h2>
    <p>{`WFP manages the United Nations Humanitarian Air Service (UNHAS), which ensures staff and vital supplies from across agencies and NGOs can be deployed rapidly and safely to the most remote and otherwise inaccessible locations. It is the only humanitarian air service that gives equal access to all humanitarian entities.`}</p>
    <p>{`In 2019, support from the EU helped keep UNHAS flying in `}<strong parentName="p">{`Cameroon`}</strong>{`, `}<strong parentName="p">{`the Central African Republic`}</strong>{`, `}<strong parentName="p">{`Chad`}</strong>{`, `}<strong parentName="p">{`the Democratic Republic of the Congo`}</strong>{`, `}<strong parentName="p">{`Mali`}</strong>{`, `}<strong parentName="p">{`Mauritania`}</strong>{`, `}<strong parentName="p">{`Niger`}</strong>{`, `}<strong parentName="p">{`South Sudan`}</strong>{`, `}<strong parentName="p">{`Sudan`}</strong>{`, `}<strong parentName="p">{`Yemen`}</strong>{` and `}<strong parentName="p">{`Zimbabwe`}</strong>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      